export const generateOperationId = (seed: number = Date.now()): string =>
    globalThis.crypto?.randomUUID?.() || `${seed}-${Math.random().toString(16).slice(2, 10)}`;

export const normalizeOperationId = (value: unknown): string | null => {
    if (typeof value !== 'string') {
        return null;
    }

    const trimmedValue = value.trim();
    return trimmedValue || null;
};

export const resolveOperationId = (value: unknown, seed: number = Date.now()): string =>
    normalizeOperationId(value) || generateOperationId(seed);
